import { default as Usage } from './Usage'
export default Usage
